import {
  AGENDA_AND_MINUTES_FORMAT,
  ATTACHMENT_MAX_SIZE,
} from '@/components/attachments/attachments';
import FileInput from '@/components/file-input/file-input';
import humanFileSize from '@Ravnur-Inc/helpers/human-file-size';
import { Attachment } from '@/types/Attachment';
import { Prop } from '@Ravnur-Inc/decorators';
import { showErrorNotification } from '@Ravnur-Inc/notifications/service';
import { Vue } from 'vue-class-component';

export default class LiveEventAttachmentInput extends Vue {
  @Prop({ type: Object as () => [File, Attachment] }) selectedAttachment: File | Attachment;

  get attachmentName() {
    let name;

    if (!this.selectedAttachment) {
      return '';
    }

    if ('name' in this.selectedAttachment) {
      name = this.selectedAttachment.name;
    }

    if ('url' in this.selectedAttachment) {
      const url = this.selectedAttachment.url;

      name = new URL(url).pathname.split('/').pop() || '';
    }

    return name;
  }

  render() {
    return (
      <FileInput
        accept={AGENDA_AND_MINUTES_FORMAT}
        aria-label="File selector"
        fileName={this.attachmentName}
        label={this.$t('common', `attachment__agenda`)}
        placeholder={this.$t('common', 'fileinput_select-a-file')}
        onClear={this.handleClearAttachment as any}
        onFileSelected={this.handleAttachmentSelected}
      />
    );
  }

  handleClearAttachment(e: Event) {
    e.preventDefault();
    this.$emit('attachment-selected', null);
  }

  handleAttachmentSelected(file: File) {
    if (file.type !== AGENDA_AND_MINUTES_FORMAT) {
      showErrorNotification(this.$t('common', 'attachment__wrong-format'));
      return;
    }

    if (file.size > ATTACHMENT_MAX_SIZE) {
      const size = humanFileSize(ATTACHMENT_MAX_SIZE);
      showErrorNotification(this.$t('common', 'attachment__max-size', { size }));
      return;
    }

    this.$emit('attachment-selected', file);
  }
}
